if (!customElements.get('gift-card-form')) {
  class GiftCardForm extends HTMLElement {

    constructor() {
      super();
      this.sendAsGift = this.querySelector('[data-send-as-gift]');
      this.giftCardName = this.querySelector('[data-gift-card-name]');
      this.giftCardEmail = this.querySelector('[data-gift-card-email]');
      this.giftCardMessage = this.querySelector('[data-gift-card-message]');
      this.giftCardDate = this.querySelector('[data-gift-card-date]');
      this.giftCardFields = this.querySelector('[data-gift-card-fields]');
      this.sendToRecipientProp = this.querySelector('[data-gift-card-recipient-prop]');
      this.sendAsGift.addEventListener('change', this.onCheckboxChange.bind(this));
      this.giftCardDate.addEventListener('focus', this._onDateFocus.bind(this));
    }

    _onDateFocus() {
      this.giftCardDate.showPicker();
    }

    _clearGiftCardFields() {
      this.giftCardName.value = '';
      this.giftCardName.removeAttribute('required');
      this.giftCardEmail.value = '';
      this.giftCardEmail.removeAttribute('required');
      this.giftCardMessage.value = '';
      this.giftCardDate.value = '';
    }

    _disableGiftCardFields() {
      this.giftCardName.setAttribute('disabled', '');
      this.giftCardEmail.setAttribute('disabled', '');
      this.giftCardMessage.setAttribute('disabled', '');
      this.giftCardDate.setAttribute('disabled', '');
    }

    _enableGiftCardFields() {
      this.giftCardName.removeAttribute('disabled');
      this.giftCardEmail.removeAttribute('disabled');
      this.giftCardMessage.removeAttribute('disabled');
      this.giftCardDate.removeAttribute('disabled');
    }

    onCheckboxChange(event) {
      if (event.target.checked) {
        this._enableGiftCardFields();
        this.giftCardFields.style.display = 'grid';
        this.giftCardName.setAttribute('required', '');
        this.giftCardEmail.setAttribute('required', '');
        this.sendToRecipientProp.removeAttribute('disabled');
      } else {
        this._clearGiftCardFields();
        this._disableGiftCardFields();
        this.giftCardFields.style.display = 'none';
        this.sendToRecipientProp.setAttribute('disabled', '');
      }
    }
  }
  customElements.define('gift-card-form', GiftCardForm);
}